const doc = [({"TextFilter":({"PlaceHolder":"Nach Parlamentarier suchen..."}), "Buttons":({"Close":"Schliessen"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;